import { Toggle, type ToggleEntry } from '@warp-ds/react/components/toggle';
import { useState } from 'react';
import type { ApiQueryParams, Month, NumberRange } from '@/interfaces';
import DatePicker from './DatePicker';
import TravelMonths from './TravelMonths';

//this is a fix for the page jumping when DatePicker gets selected on mobile, REIS-4289
const storePageOffsetY = (): void => {
    if (typeof Storage !== 'undefined' && window.pageYOffset !== 0) {
        window.sessionStorage.setItem('pageOffsetY', window.pageYOffset.toString());
    }
};

export interface TravelTimePickerProps {
    travelMonths: Month[];
    duration?: NumberRange;
    setIgnoredFilters: (filters: string[]) => void;
    triggerFetch: (queryParams?: ApiQueryParams) => void;
}

export const TravelTimePicker = ({ travelMonths, duration, setIgnoredFilters, triggerFetch }: TravelTimePickerProps) => {
    const [flexibleSearch, setFlexibleSearch] = useState(travelMonths.length !== 0 || !!duration);

    const pickFixedSearch = (): void => {
        storePageOffsetY();
        setFlexibleSearch(false);
        setIgnoredFilters(['duration', 'travelMonths']);
        triggerFetch();
    };

    const pickFlexibleSearch = (): void => {
        setFlexibleSearch(true);
        setIgnoredFilters(['departureDate', 'returnDate']);
        triggerFetch();
    };

    const onChange = (entry: ToggleEntry): void => {
        if (entry.value === 'fixed') {
            pickFixedSearch();
        } else {
            pickFlexibleSearch();
        }
    };

    const options: ToggleEntry[] = [
        { label: 'Fast dato', value: 'fixed' },
        { label: 'Fleksibel dato', value: 'flexible' },
    ];

    const selected: ToggleEntry[] = options.filter((option) => option.value === (flexibleSearch ? 'flexible' : 'fixed'));

    return (
        <div id="departure-container" className="space-y-16 mt-16">
            <Toggle type="radio" options={options} selected={selected} onChange={onChange} className="flex gap-16" />

            {flexibleSearch ? <TravelMonths triggerFetch={triggerFetch} /> : <DatePicker triggerFetch={triggerFetch} />}
        </div>
    );
};
